const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCAgZD0iTTE5LjI5MyA3LjI5M2wxLjQxNCAxLjQxNEwxMiAxNy40MTQgMy4yOTMgOC43MDdsMS40MTQtMS40MTRMMTIgMTQuNTg2eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=arrow_down-64629c2c.mjs.map
